<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>招标</span><span style="color:#D7230C;">通告</span></div>
							<div class="sm_pub">招标通告</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">招标通告</div>
				</div>
				<!-- <div class="Bigcosousuo">
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div> -->
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom" style="height: 950px;">
				<div style="width: 95%;margin: 0 auto;height: 800px;">
						<div style="width: 100%;height: 70px;">
							<div
								style="float: left;width: 20%;height: 70px;line-height: 70px;text-align: center;margin-left: 5%;font-size: 20px;font-weight: 800;">
								日期
							</div>
							<div
								style="float: left;width: 15%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
								项目类型
							</div>
							<div
								style="float: left;width: 15%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
								单位类型
							</div>
							<div
								style="float: left;width: 40%;height: 70px;line-height: 70px;text-align: center;font-size: 20px;font-weight: 800;">
								招标采购标题
							</div>
						</div>
						<div @click="das(item.id,item.title)" style="width: 100%;height: 65px;margin-top: 10px;float: left;box-shadow: 0 4px 24px rgba(0,0,0,.16);"
							v-for="(item,index) in dataList" :key="index">
							<div
								style="float: left;width: 20%;height: 65px;line-height: 65px;text-align: center;font-size: 14px;margin-left: 5%;">
								{{getLocalTime(item.create_time)}}
							</div>
							<div
								style="float: left;width: 15%;height: 65px;line-height: 65px;text-align: center;font-size: 14px;">
								{{item.xm_type}}
							</div>
							<div
								style="float: left;width: 15%;height: 65px;line-height: 65px;text-align: center;font-size: 14px;">
								{{item.unit_type}}
							</div>
							<div
								style="float: left;width: 40%;height: 65px;line-height: 65px;text-align: center;font-size: 14px;">
								{{item.title}}
							</div>
						</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="PageSize" layout="total, prev, pager, next"
						:total="Totals">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
		<dashang ref="dashang"></dashang>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				dataLists: '',
				currentPage: 1, //当前页
				PageSize: 12, //当前每页数据
				Totals: 100, //总数据条数
				keyword: '', //搜索框查询关键字
				dataList: [],
			}
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
		},
		async mounted() {
			let res = await http.get('api/picture/zbtg_index')
			console.log(res)
			this.dataList = res.data.data.list
			this.Totals = res.data.data.count
			this.PageSize = res.data.data.rows_limit
		},
		methods: {
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容')
				}
				let res = await http.post('api/Common/index', {
					model: 'xp',
					type: 'content',
					mid: '1',
					title: this.keyword
				})
				this.dataList = res.data.data.list.data
				this.Totals = res.data.data.list.total
				this.currentPage = res.data.data.list.current_page
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			async das(id, sb) {
				let that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.sid = loginInfo.id
				if (loginInfo) {
					let res = await http.post('api/picture/login_yz', {
						tid: id,
						nologin_type: 'zbtg',
						uid: loginInfo.id
					})
			
					console.log(res)
					if (res.data.code == 500) {
						this.$refs.dashang.DS_ck(20, '查看招标通告', 'zbtg', id)
						// that.$refs.child.isShowZF = true //修改子组件data
					} else {
						this.$router.push({
							path:`/zbggdetail?id=${id}&title=${sb},`
						})
					}
				} else {
					this.$message.error('请先登录');
					this.$router.replace('/login')
				}
			},
			handleSizeChange(val) {},
			async handleCurrentChange(val) {
				let res = await http.post('api/picture/page_zbtg',{
					page:val
				})
				this.dataList = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			}
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1000px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 50px;
	}

	.Bigcosousuo>input {
		width: 65%;
		height: 30px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 30%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
		background-color: #D7230C;
	}

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1150px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.NewArrialsb:hover {
		box-shadow: #6e6e6e 0px 0px 10px;
	}
</style>
